import React, { useContext } from 'react';
import { MainNavbar } from './navbar';
import { HomePage } from './home';
import { AppContext } from '../App';
import { Staff } from './staff';
import { QuickReport } from './quick_report';
import { QuickLinks } from './quick_links';
import { Ads } from './ads';
import { Agents } from './agents';
import { RenewAccount } from './renew';
import { Invoice } from './invoice';
import { Enquiry } from './enquiry';

export const Dashboard = () => {
	const { page } = useContext(AppContext);


	return (
		<div className="dashboard-wraper">
			<MainNavbar />
			<Invoice />
			{
				page !== undefined ? (
					page === 'home' ? (
						<HomePage />
					) : page === 'quick_report' ? (
						<QuickReport />
					) : page === 'staff' ? (
						<Staff />
					) : page === 'quick_links' ? (
						<QuickLinks />
					) : page === 'ads' ? (
						<Ads />
					) : page === 'agent' ? (
						<Agents />
					) : page === 'renew' ? (
						<RenewAccount />
					) : page === 'enquiry' ? (
						<Enquiry />
					) : ''
				) : ''
			}
		</div>
	)
}